import { AppContext, Features } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl'
import {
    Link,
    Redirect
} from 'react-router-dom'
import Select from 'react-select'
import CalendarVisiblitySelect from "../../calendar/calendarvisibilityselect.component.jsx"
import ActionButton from "../../common/button/actionbutton.component.jsx"
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import ConnectIntegrationButton from "../../common/button/connectintegrationbutton.component.jsx"
import Icon from "../../common/icon/icon.component.jsx"
import { getEventName } from '../../name-helpers/eventNameHelper'
import { getNylasVersion } from '../../utils/common/utils'
import ExternalCalendarSelect from "../externalcalendarselect.component.jsx"
class CalendarEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            id: '',
            title: '',
            description: '',
            deleteButton: '',
            externalId: '',
            externalAccountId: '',
            email: '',
            userId: AppContext.getUserLoggedIn().id,
            integrationKey: '',
            calendarIntegration: null,
            isSaving: false,
            visibility: 'public',
            defaultLocation: '',
        }
        this.submitCalendar = this.submitCalendar.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.deleteCalendar = this.deleteCalendar.bind(this)
    }

    componentDidMount() {
        const calendar = this.props.calendar
        if (calendar && calendar.id) {
            const deleteButton = <ConfirmButton identifier={calendar.attributes.title} onClick={this.deleteCalendar} className="btn btn-danger">
                <FormattedMessage
                    id="calendar.form.edit.delete_btn"
                    defaultMessage="Delete calendar"
                />
            </ConfirmButton>
            this.setState({
                id: calendar.id,
                description: calendar.attributes.description,
                title: calendar.attributes.title,
                externalId: calendar.attributes.externalLink ? calendar.attributes.externalLink.attributes.externalId : '',
                deleteButton: deleteButton,
                email: calendar.attributes.email,
                visibility: calendar.attributes.visibility,
                defaultLocation: calendar.attributes.defaultLocation,
            })
        }
        this.loadCalendarIntegration()
    }

    loadCalendarIntegration() {
        if (this.state.userId) {
            const userIntegrations = AppContext.integrations.filter(it => it.attributes.userId === this.state.userId)
            for (let integration of userIntegrations) {
                if (integration.attributes.enabledFeatures[Features.Scheduling]) {
                    this.setState({
                        calendarIntegration: integration,
                        externalAccountId: integration.attributes.configuration.accountId,
                        integrationKey: integration.attributes.integrationKey,
                        email: integration.attributes.configuration.email,
                    })
                    break
                }
            }
        }
    }

    deleteCalendar(event) {
        const calendar = this.props.calendar
        AppContext.getApiClient().delete('/calendars/' + calendar.id).then((response) => {
            let formStatus = ''
            if (!response.error) {
                formStatus = <Redirect
                    to={{
                        pathname: '/calendars/listing'
                    }}
                />
            } else {
                this.setState({
                    isSaving: false,
                })
                return
            }
            setTimeout(() => {
                this.setState({
                    formStatus: formStatus,
                    isSaving: false,
                })
            }, 1000)
        })

        event.preventDefault()
    }

    saveCalendar() {
        const calendar = this.props.calendar
        if (calendar && calendar.id) {
            let updates = {}
            const allowedFields = [
                "description",
                "title",
                'visibility',
                'defaultLocation',
            ]
            for (let i = 0; i < allowedFields.length; i++) {
                let field = allowedFields[i]
                if (calendar.attributes[field] != this.state[field]) {
                    updates[field] = this.state[field]
                }
            }
            return AppContext.getApiClient().patch('/calendars/' + calendar.id, updates)
        } else {
            return AppContext.getApiClient().post('/calendars', {
                "externalId": this.state.externalId,
                "externalAccountId": this.state.externalAccountId,
                "userId": this.state.userId,
                "description": this.state.description,
                "title": this.state.title,
                "integrationKey": this.state.integrationKey,
                "email": this.state.email,
                "visibility": this.state.visibility,
                "defaultLocation": this.state.defaultLocation,
            })
        }
    }

    submitCalendar(event) {
        event.preventDefault()
        this.setState({
            isSaving: true,
        })
        this.saveCalendar().then((response) => {
            let formStatus = ''
            if (!response.error) {
                formStatus = <Redirect
                    to={{
                        pathname: '/calendars/listing'
                    }}
                />
            } else {
                this.setState({
                    isSaving: false,
                })
                return
            }
            setTimeout(() => {
                this.setState({
                    formStatus: formStatus,
                    isSaving: false,
                })
            }, 1000)
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    render() {
        const messages = defineMessages({
            "calendar.form.edit.description_placeholder": {
                id: 'calendar.form.edit.description_placeholder',
                defaultMessage: 'Description of the calendar',
            },
            "calendar.form.edit.title_placeholder": {
                id: 'calendar.form.edit.title_placeholder',
                defaultMessage: 'Title of the calendar',
            },
            "calendar.form.edit.calendar_placeholder": {
                id: 'calendar.form.edit.calendar_placeholder',
                defaultMessage: 'Select a calendar',
            },
            "calendar.form.edit.save_btn": {
                id: 'calendar.form.edit.save_btn',
                defaultMessage: 'Save calendar',
            },
            "calendar.form.edit.connect_email_account": {
                id: 'calendar.form.edit.connect_email_account',
                defaultMessage: 'Connect your email account',
            },
            "calendar.form.edit.location_placeholder": {
                id: 'calendar.form.edit.location_placeholder',
                defaultMessage: 'Default location for {eventName}s booked on this calendar',
            },
        })

        const nylasKey = getNylasVersion()
        const userIdOfUserBeingModified = AppContext.getUserLoggedIn().id
        const nylasUrl = AppContext.getOptions().apiUrl + '/openid/connect/' + nylasKey + '/' +
            userIdOfUserBeingModified + '?r=/calendars/listing'

        return (
            <form onSubmit={this.submitCalendar}>
                <div className="row ui-has-modules">
                    {(this.state.calendarIntegration || this.state.id) ?
                        <div className="col-12 ui-module">
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="emailAccount">
                                    <FormattedMessage
                                        id="calendar.form.edit.select_account"
                                        defaultMessage="Email account"
                                    />
                                </label>
                                <div className="col-10">
                                    {/* Eventually, we could select an email account which is connected to the QM account but not to a specific user */}
                                    <Select
                                        name={'emailAccount'}
                                        value={this.state.externalAccountId}
                                        options={[{
                                            value: this.state.externalAccountId,
                                            label: this.state.email,
                                        }]}
                                        disabled={true}
                                        clearable={false}
                                        searchable={false}
                                        multi={false}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="calendarDescription">
                                    <FormattedMessage
                                        id="calendar.form.edit.select_calendar"
                                        defaultMessage="Calendar"
                                    />
                                </label>
                                <div className="col-10">
                                    <ExternalCalendarSelect
                                        value={this.state.externalId}
                                        userId={this.state.userId}
                                        calendarIntegration={this.state.calendarIntegration}
                                        onChange={(externalId, title) => {
                                            this.setState({
                                                externalId,
                                                title,
                                            })
                                        }}
                                        disabled={this.state.id ? true : false} />
                                    {!this.state.id &&
                                        <small className="form-text text-muted">
                                            <FormattedMessage
                                                id="calendar.form.edit.calendar_description"
                                                defaultMessage="Choose a calendar among the calendars which are linked to the selected email account"
                                            />
                                        </small>
                                    }
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="calendarVisibility">
                                    <FormattedMessage
                                        id="calendar.form.edit.visibility_label"
                                        defaultMessage="Visibility"
                                    />
                                </label>
                                <div className="col-10">
                                    <CalendarVisiblitySelect
                                        visibility={this.state.visibility}
                                        onChange={visibility => {
                                            this.setState({
                                                visibility: visibility,
                                            })
                                        }} />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="calendarTitle">
                                    <FormattedMessage
                                        id="calendar.form.edit.title_label"
                                        defaultMessage="Title"
                                    />
                                </label>
                                <div className="col-10">
                                    <input
                                        name="title"
                                        value={this.state.title}
                                        onChange={this.handleFormChange}
                                        id="titleDescription"
                                        type="text"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages['calendar.form.edit.title_placeholder'])}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="calendarDescription">
                                    <FormattedMessage
                                        id="calendar.form.edit.description_label"
                                        defaultMessage="Description"
                                    />
                                </label>
                                <div className="col-10">
                                    <textarea
                                        name="description"
                                        value={this.state.description}
                                        onChange={this.handleFormChange}
                                        id="labelDescription"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages['calendar.form.edit.description_placeholder'])}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="calendarDefaultLocation">
                                    <FormattedMessage
                                        id="calendar.form.edit.default_location_label"
                                        defaultMessage="Default location"
                                    />
                                </label>
                                <div className="col-10">
                                    <input
                                        name="defaultLocation"
                                        value={this.state.defaultLocation}
                                        onChange={this.handleFormChange}
                                        id="defaultLocationDescription"
                                        type="text"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages['calendar.form.edit.location_placeholder'], {
                                            eventName: getEventName(this.props.intl)
                                        })}
                                    />
                                </div>
                            </div>

                            {
                                this.props.calendar && this.props.calendar.attributes.userId ?
                                    <div className="form-group row">
                                        <label className="col-2 col-form-label text-align-right">
                                        </label>
                                        <div className="col-10">
                                            <small>
                                                <FormattedMessage
                                                    id="calendar.form.edit.added_by_label"
                                                    defaultMessage="Calendar added by {userName}"
                                                    values={{
                                                        userName: this.props.calendar.attributes.user.attributes.name,
                                                    }}
                                                />
                                            </small>
                                        </div>
                                    </div> : ''
                            }

                        </div>
                        :
                        <div className="col-12 ui-module">
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right">
                                </label>
                                <div className="col-10">
                                    <ConnectIntegrationButton
                                        integrationKey={nylasKey}
                                        url={nylasUrl}
                                        className="btn-outline-primary"
                                        label={
                                            <div>
                                                <Icon value={'envelope'} className={'mr-2 fa-lg'} />
                                                {this.props.intl.formatMessage(messages['calendar.form.edit.connect_email_account'])}
                                            </div>
                                        }
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="calendar.form.edit.nylas_connect_description"
                                            defaultMessage="Connect your personal email account to add calendars for the scheduling feature"
                                        />
                                    </small>
                                </div>
                            </div>
                        </div>}
                    <div className="col-12">
                        {this.state.formStatus}
                    </div>
                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6">
                                {this.state.deleteButton}
                            </div>
                            <div className="col-6 text-align-right">
                                <Link to="/calendars/listing" className="btn btn-light">
                                    <FormattedMessage
                                        id="calendar.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <ActionButton
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={!this.state.externalId || !this.state.title || !this.state.calendarIntegration}
                                    isLoading={this.state.isSaving}
                                    onClick={this.submitCalendar}
                                >
                                    {this.props.intl.formatMessage(messages['calendar.form.edit.save_btn'])}
                                </ActionButton>

                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default injectIntl(CalendarEditForm)


// WEBPACK FOOTER //
// ./src/calendar/components/CalendarEditFormComponent.jsx